module.exports = __webpack_public_path__ + "static/media/teygja_brjostvodvar.76220a47.png";